import { Link } from '@checkatrade/web-ui';
import NextLink from 'next/link';
import { useIsAuthenticated } from 'lib/auth/auth.hooks';
import { Badge } from 'components/Dashboard/badge';
import { useLazyChat } from 'lib/chat/use-lazy-chat';
import { Profile, ProfileFill } from '@cat-home-experts/mortar-iconography-web';
import { colors } from '@checkatrade/web-ui/themes';

export const LoginButton = ({
  handleMegaClickOutside,
}: {
  handleMegaClickOutside: () => void;
}) => {
  const isAuthenicated = useIsAuthenticated();

  const { unreadCount } = useLazyChat();

  return (
    <Link
      href="/account"
      data-guid="TopNavLogin"
      as={NextLink}
      aria-label={isAuthenicated ? 'Account' : 'Login'}
      onClick={handleMegaClickOutside}
    >
      <Badge
        dot
        classNames={{ badge: 'top-0 right-0' }}
        show={!!unreadCount && unreadCount > 0}
      >
        {isAuthenicated ? (
          <Profile size={30} color={colors.secondary.DEFAULT} />
        ) : (
          <ProfileFill size={30} color={colors.secondary.DEFAULT} />
        )}
      </Badge>
    </Link>
  );
};
